import { render, staticRenderFns } from "./_dp_pesquisaMobile.vue?vue&type=template&id=6b31fa4e&scoped=true&"
import script from "./_dp_pesquisaMobile.vue?vue&type=script&lang=js&"
export * from "./_dp_pesquisaMobile.vue?vue&type=script&lang=js&"
import style0 from "./_dp_pesquisaMobile.vue?vue&type=style&index=0&id=6b31fa4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31fa4e",
  null
  
)

export default component.exports